// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */ import { ReactComponent as GemPrepareExtended } from '../../../../../ui-v3/src/assets/icons/extended/entities/gem-prepare.svg?react';
import { createIcons } from '../../Icon';
const GemPrepareIcon = /* @__PURE__ */ createIcons('GemPrepare', {
    extended: GemPrepareExtended
});
GemPrepareIcon.supportedTypes = [
    'extended'
];
GemPrepareIcon.category = 'entities';
export default GemPrepareIcon;
